import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import NoPermissionModal from 'components/security/NoPermissionModal';

export default class NoPermissionIcon extends Component {

  static propTypes = {
    onPermissionGiven: PropTypes.func,

    permission: PropTypes.func
  };

  state = {
    shouldDisplayModal: false
  };

  //
  // Events
  //
  onClick = () => {
    this.setState({
      shouldDisplayModal: true
    });
  };

  onHideModal = () => {
    this.setState({
      shouldDisplayModal: false
    });
  };

  //
  // Renderers
  //

  renderModal() {
    return (
      <NoPermissionModal
        onHide={this.onHideModal}
        show={this.state.shouldDisplayModal}
        permission={this.props.permission}
      />
    );
  }

  render() {
    return (
      <span>
        <i
          className="fa fa-lock no_permission_icon"
          onClick={this.onClick}
        />
        {this.renderModal()}
      </span>
    );
  }

}
